import { Inject, Injectable, InjectionToken } from '@angular/core';

import {
  CanvasAppPreference,
  DeviceManagerAppPreference,
  LayoutMenuAppPreference,
  NetworkSettingsAppPreference,
  PaletteManagerAppPreference,
  PreferenceLoader,
  PreferenceService,
  ReadingsAppPreference,
} from '@olympus/ngx-shared';
import { AmplitudeSystem, UnitSystem } from 'shared-utils/unit';

import { UtDesktopMode } from './config/feature-flags.config';

export const APP_PREFERENCE_INITIALIZERS: InjectionToken<any> = new InjectionToken<any>('APP_PREFERENCE_INITIALIZERS');

export function windViewPreferenceInitializer(): WindViewAppPreference {
  return {
    RibbonUTSettingsShowAdvanced: false,
    UnitSystem: 'metric',
    AmplitudeSystem: 'percent',
    fileIsUploading: false,
    applicationMode: null,
  };
}

/* eslint-disable @typescript-eslint/naming-convention */
export type WindViewAppPreference = {
  RibbonUTSettingsShowAdvanced: boolean,
  UnitSystem: UnitSystem,
  AmplitudeSystem: AmplitudeSystem,
  fileIsUploading: boolean,
  applicationMode: UtDesktopMode | null,
};
/* eslint-enable @typescript-eslint/naming-convention */

export type WindViewPreferenceType =
  & WindViewAppPreference
  & ReadingsAppPreference
  & NetworkSettingsAppPreference
  & CanvasAppPreference
  & LayoutMenuAppPreference
  & PaletteManagerAppPreference
  & DeviceManagerAppPreference;

@Injectable({
  providedIn: 'root',
})
export class WindViewPreference extends PreferenceService<WindViewPreferenceType> {
  constructor(@Inject(APP_PREFERENCE_INITIALIZERS) preference: any[], loader: PreferenceLoader) {
    super(preference, loader);
  }
}
